<template>
  <div class="dashboard">
    <!-- Dashboard Cards -->
    <div class="card-grid">
      <div class="card" v-for="item in cards" :key="item.title" :click="() => $router.push(item.href)">
        <i :class="item.icon"></i>
        <p>{{ item.title }}</p>
      </div>
      <!-- Quick Add Button -->
      <button class="add-button">
        <i class="el-icon-plus"></i>
      </button>
    </div>
  </div>
</template>

<script>
import script from '../../script/script.js';

export default {
  data() {
    return {
      cards: [
        { title: 'Tiers', icon: 'el-icon-user', href:'/tiers' },
        { title: 'Tickets', icon: 'el-icon-tickets', href:'/suiviTicketAdmin' },
        { title: 'Comptabilité', icon: 'el-icon-tools', href:'' },
        { title: 'Contrats de Service', icon: 'el-icon-document', href:'/contratDeService' },
        { title: 'Fournisseurs', icon: 'el-icon-office-building', href:'/fournisseur' }
      ]
    }
  },
  mounted:function(){
    this.verifyRight();
  },
  computed:{
  },
  methods: {
    verifyRight: script.verifyRight
  }
  
}
</script>

<style>

</style>
<style scoped>
.dashboard {
  background-color: #f7f9fc;
  min-height: 100vh;
}
.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 20px;
  padding: 40px;
  position: relative;
}
.card {
  background: white;
  border-radius: 12px;
  padding: 30px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  font-size: 16px;
  color: #333;
}
.card i {
  font-size: 32px;
  margin-bottom: 10px;
  display: block;
  color: #3ba0e9;
}
.add-button {
  position: fixed;
  bottom: 30px;
  left: 30px;
  width: 56px;
  height: 56px;
  background-color: #3ba0e9;
  color: white;
  border: none;
  border-radius: 50%;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>
